import { gql } from '@apollo/client';
export const CREATE_CAREPLAN = gql`
  mutation createCareplan($diagnosisId: ID, $patientId: ID) {
    createCareplan(diagnosisId: $diagnosisId, patientId: $patientId) {
      success
      careplan {
        id
        careplanName
        careplanStatus
        isPrimDiagnosisOwner
        isMetsDiagnosisOwner
        featureVersion
      }
    }
  }
`;

export const UPDATE_CAREPLAN_DIAGNOSIS = gql`
  mutation updateCareplanDiagnosis($careplanId: ID!, $diagnosisId: ID, $relatedPrimaryDiagnosisId: ID) {
    updateCareplanDiagnosis(
      careplanId: $careplanId
      diagnosisId: $diagnosisId
      relatedPrimaryDiagnosisId: $relatedPrimaryDiagnosisId
    ) {
      success
      careplan {
        id
      }
      diagnosis
    }
  }
`;

export const GET_CAREPLAN_PRESCRIPTIONS = gql`
  query prescriptionsByCareplan($careplanId: ID!) {
    prescriptionsByCareplan(careplanId: $careplanId) {
      id
      name
      selectionMethod
      orderRanking
      template {
        id
        template {
          id
        }
      }
      volumingvaluesSet {
        id
        field {
          id
          name
        }
        hasVaried
        value
      }
      sitegroupSet {
        id
        name
        template {
          id
        }
        imagingList {
          id
        }
        sitegroupvaluesSet {
          id
          field {
            id
            name
          }
          hasVaried
          value
        }
        siteSet {
          id
          orderRanking
          treatmentSite {
            id
            treatmentSite
            defaultLaterality
          }
          template {
            id
          }
          sitevaluesSet {
            id
            field {
              id
              name
            }
            hasVaried
            value
          }
        }
      }
    }
  }
`;
export const GET_CAREPLAN_SITE_GROUPS = gql`
  query siteGroupsByCareplan($careplanId: ID!) {
    siteGroupsByCareplan(careplanId: $careplanId) {
      id
      name
      selectionMethod
      template {
        id
        template {
          id
        }
      }
      imagingList {
        id
      }
      sitegroupvaluesSet {
        id
        field {
          id
          name
        }
        hasVaried
        value
      }
      siteSet {
        id
        treatmentSite {
          id
          treatmentSite
          defaultLaterality
        }
        template {
          id
        }
        sitevaluesSet {
          id
          field {
            id
            name
          }
          hasVaried
          value
        }
      }
    }
  }
`;

export const DELETE_SITE = gql`
  mutation deleteSite($id: ID!) {
    deleteSite(id: $id) {
      success
    }
  }
`;

export const LINK_SITE = gql`
  mutation linkSiteGroup($siteGroupId: ID!, $siteId: ID!) {
    linkSiteGroup(siteGroupId: $siteGroupId, siteId: $siteId) {
      success
    }
  }
`;

export const UNLINK_SITE = gql`
  mutation unlinkSite($siteId: ID!, $careplanId: ID!, $originalSiteGroupId: ID!) {
    unlinkSite(siteId: $siteId, careplanId: $careplanId, originalSiteGroupId: $originalSiteGroupId) {
      success
    }
  }
`;

export const DELETE_SITE_GROUP = gql`
  mutation deleteSiteGroup($id: ID!) {
    deleteSiteGroup(id: $id) {
      success
    }
  }
`;

export const UPDATE_SITE = gql`
  mutation updatePrescription($siteId: ID!, $laterality: String, $location: String) {
    updatePrescription(siteId: $siteId, laterality: $laterality, location: $location) {
      site {
        id
        location
      }
    }
  }
`;
export const UPDATE_GROUP_LATERALITY = gql`
  mutation updateGroupLaterality($siteGroupId: ID!, $siteId: ID!, $laterality: String!) {
    updateGroupLaterality(siteGroupId: $siteGroupId, siteId: $siteId, laterality: $laterality) {
      success
    }
  }
`;

export const UPDATE_PRESCRIPTION_LATERALITY = gql`
  mutation updatePrescriptionLaterality($prescriptionId: ID!, $siteId: ID!, $laterality: String!) {
    updatePrescriptionLaterality(prescriptionId: $prescriptionId, siteId: $siteId, laterality: $laterality) {
      success
    }
  }
`;

export const CONDITIONAL_FIELD_LIST = gql`
  query conditionalFieldList {
    conditionalFieldList {
      id
      name
    }
  }
`;

export const UPDATE_SITE_VALUE = gql`
  mutation updateSiteValue($id: ID!, $siteId: ID!, $fieldName: String, $value: String!) {
    updateSiteValue(id: $id, siteId: $siteId, fieldName: $fieldName, value: $value) {
      siteValues {
        id
        hasVaried
      }
    }
  }
`;

export const UPDATE_SITE_GROUP_VALUE = gql`
  mutation updateSiteGroupValue($id: ID!, $siteGroupId: ID!, $fieldName: String, $value: String!) {
    updateSiteGroupValue(id: $id, siteGroupId: $siteGroupId, fieldName: $fieldName, value: $value) {
      siteGroupValue {
        id
        field {
          id
          name
        }
        value
      }
    }
  }
`;

export const GET_INTAKE_CODE_MAPPING = gql`
  query {
    intakeCodeMapping {
      id
      intake {
        id
        name
      }
      diagnosisCode {
        id
        diagnosisCode
      }
    }
  }
`;

export const UPDATE_CAREPLAN_LAST_PAGE = gql`
  mutation updateCareplan($id: ID!, $latestPageUrl: String) {
    updateCareplan(id: $id, latestPageUrl: $latestPageUrl) {
      careplan {
        id
        latestPageUrl
        featureVersion
      }
    }
  }
`;

export const SOFT_DELETE_CAREPLAN = gql`
  mutation softDeleteCareplan($id: ID!) {
    softDeleteCareplan(id: $id) {
      careplan {
        id
      }
    }
  }
`;

export const GET_CAREPLAN_STATUS = gql`
  query careplan($id: ID!) {
    careplan(id: $id) {
      id
      careplanStatus
      parent {
        id
        submittedAt
      }
    }
  }
`;

export const FETCH_PLANS = gql`
  query fetchPlans($id: ID!) {
    fetchPlans(id: $id) {
      careplan {
        id
        careplanStatus
      }
      iguanaResponse
      success
      errorMessage
      planManagementId
    }
  }
`;

export const UPDATE_PLAN_MANAGEMENT_USER_CANCELLATION = gql`
  mutation UpdatePlanManagementUserCancellation($planManagementId: ID!) {
    updatePlanManagementUserCancellation(planManagementId: $planManagementId) {
      success
      message
    }
  }
`;

export const UPDATE_PLAN_MANAGEMENT_USER_SELECTION = gql`
  mutation UpdatePlanManagementUserSelection($planManagementId: ID!, $userSelectedOption: String!) {
    updatePlanManagementUserSelection(planManagementId: $planManagementId, userSelectedOption: $userSelectedOption) {
      success
      message
    }
  }
`;

export const UPDATE_PLAN_MANAGEMENT_NO_UNAPPROVAL_REQUIRED = gql`
  mutation UpdatePlanManagementNoUnapprovalRequired($planManagementId: ID!, $noUnapprovalRequired: Boolean!) {
    updatePlanManagementNoUnapprovalRequired(
      planManagementId: $planManagementId
      noUnapprovalRequired: $noUnapprovalRequired
    ) {
      success
      message
    }
  }
`;

export const UPDATE_PLAN_MANAGEMENT_USER_ACKNOWLEDGED_ERROR = gql`
  mutation UpdatePlanManagementUserAcknowledgedError($planManagementId: ID!, $userAcknowledgedError: Boolean!) {
    updatePlanManagementUserAcknowledgedError(
      planManagementId: $planManagementId
      userAcknowledgedError: $userAcknowledgedError
    ) {
      success
      message
    }
  }
`;

export const SITE_GROUP_TEMPLATE_VALUE_VARIATION = gql`
  query siteGroupTemplateValueVariation($siteGroupId: ID!) {
    siteGroupTemplateValueVariation(siteGroupId: $siteGroupId) {
      variation
    }
  }
`;

export const SITE_TEMPLATE_VALUES_BY_GROUP_VARIATION = gql`
  query siteTemplateValuesByGroupVariation($siteGroupId: ID!, $volumingPage: Boolean) {
    siteTemplateValuesByGroupVariation(siteGroupId: $siteGroupId, volumingPage: $volumingPage) {
      variation
    }
  }
`;

export const GET_CAREPLAN = gql`
  query careplan($id: ID!) {
    careplan(id: $id) {
      id
      careplanStatus
      templateChangeRequested
      treatingDepartment
      submittedAt
      simulationModification
      prescriptionModification
      diagnosisModification
      intakeModification
      cied
      ciedPatientDependancy
      ciedLinacRequired
      changeType
      parent {
        id
        careplanStatus
        changeType
        submittedAt
      }
      practitioner {
        id
      }
      isPrimDiagnosisOwner
      isMetsDiagnosisOwner
      ajccMajorVersion
      featureVersion
    }
  }
`;

export const SITE_TEMPLATE_VALUES_IN_SITE_GROUP = gql`
  query siteGroupTemplate($siteGroupId: ID!) {
    siteGroupTemplate(id: $siteGroupId) {
      id
      treatmentsiteprescriptiontemplateSet {
        id
        treatmentrulesiteSet {
          id
          field {
            id
            name
          }
          defaultValue
        }
      }
    }
  }
`;

export const FREQUENTLY_USED_TEMPLATES = gql`
  query frequentlyUsedTemplates($patientId: ID!, $tumourStream: String!) {
    frequentlyUsedTemplates(patientId: $patientId, tumourStream: $tumourStream) {
      id
      name
      ranking
      approvedDate
    }
  }
`;

export const SIGMA_DATA = gql`
  query sigmaData($careplanId: ID!) {
    sigmaData(careplanId: $careplanId) {
      id
      responseUUID
      status
      validationErrors {
        field
        message
      }
      templates {
        id
        name
        score
      }
    }
  }
`;

export const USER_DATA = gql`
  query user {
    user {
      id
      isShowcaseUser
    }
  }
`;

export const TRIGGER_CPOT = gql`
  mutation updateCareplan($id: ID!, $careplanStatus: String, $cpotTriggered: Boolean) {
    updateCareplan(id: $id, careplanStatus: $careplanStatus, cpotTriggered: $cpotTriggered) {
      careplan {
        id
        careplanStatus
        cpotTriggered
      }
    }
  }
`;

export const UPDATE_TREATMENT_SITE = gql`
  mutation updateTreatmentSite($siteId: ID!, $treatmentSite: String) {
    updateTreatmentSite(siteId: $siteId, treatmentSite: $treatmentSite) {
      success
    }
  }
`;

export const SITE_NAME_VARIATION = gql`
  query siteNameVariation($careplanId: ID!) {
    siteNameVariation(careplanId: $careplanId) {
      variation
    }
  }
`;

export const GET_CAREPLAN_SITE_LIST = gql`
  query siteListByCareplan($careplanId: ID!) {
    siteListByCareplan(careplanId: $careplanId) {
      id
      laterality
      treatmentSite
    }
  }
`;

export const GET_QUESTION = gql`
  query questionByType($type: String!) {
    questionByType(formType: $type) {
      id
      type
      values
      isActive
    }
  }
`;

export const UPDATE_SPECIAL_PHYSICS_CONSULT = gql`
  mutation updateSpecialPhysicsConsult($prescriptionId: ID!, $value: String) {
    updateSpecialPhysicsConsult(prescriptionId: $prescriptionId, value: $value) {
      success
    }
  }
`;

export const DISCARD_CAREPLAN_CHANGES = gql`
  mutation discardCareplanChanges($id: ID!) {
    discardCareplanChanges(id: $id) {
      careplanId
      careplanStatus
    }
  }
`;

export const MOVE_SITE_TO_SIM_GROUP = gql`
  mutation moveSiteToSimGroup($siteId: ID!, $simGroupId: ID) {
    moveSiteToSimGroup(siteId: $siteId, simGroupId: $simGroupId) {
      success
    }
  }
`;

export const MOVE_SITE_TO_PRESCRIPTION = gql`
  mutation moveSiteToPrescription($siteId: ID!, $prescriptionId: ID) {
    moveSiteToPrescription(siteId: $siteId, prescriptionId: $prescriptionId) {
      success
    }
  }
`;

export const CLEAN_CAREPLAN = gql`
  mutation cleanCareplan($careplanId: ID!) {
    cleanCareplan(careplanId: $careplanId) {
      success
    }
  }
`;

export const DELETE_PRESCRIPTION = gql`
  mutation deletePrescription($prescriptionId: ID!) {
    deletePrescription(prescriptionId: $prescriptionId) {
      success
    }
  }
`;

export const VOLUMING_TEMPLATE_VALUE_VARIATION = gql`
  query volumingTemplateValueVariation($prescriptionId: ID!) {
    volumingTemplateValueVariation(prescriptionId: $prescriptionId) {
      variation
    }
  }
`;

export const SITE_TEMPLATE_VALUES_BY_PRESCRIPTION_VARIATION = gql`
  query siteTemplateValuesByPrescriptionVariation($prescriptionId: ID!, $volumingPage: Boolean) {
    siteTemplateValuesByPrescriptionVariation(prescriptionId: $prescriptionId, volumingPage: $volumingPage) {
      variation
    }
  }
`;

export const UPDATE_VOLUMING_VALUE = gql`
  mutation roUpdateVolumingValue($id: ID!, $prescriptionId: ID!, $fieldName: String!, $value: String!) {
    roUpdateVolumingValue(id: $id, prescriptionId: $prescriptionId, fieldName: $fieldName, value: $value) {
      volumingValue {
        id
        field {
          id
          name
        }
        value
      }
    }
  }
`;
export const SITE_TEMPLATE_VALUES_IN_PRESCRIPTION = gql`
  query prescriptionTemplate($prescriptionId: ID!) {
    prescriptionTemplate(id: $prescriptionId) {
      id
      sitegrouptemplateSet {
        id
        treatmentsiteprescriptiontemplateSet {
          id
          treatmentrulesiteSet {
            id
            field {
              id
              name
            }
            defaultValue
          }
        }
      }
    }
  }
`;

export const GET_SUBMISSION_PREVIEW_DOCUMENTS = gql`
  query previewDocuments($careplanId: ID!) {
    previewDocuments(careplanId: $careplanId) {
      id
      previewUrl
      prescriptionId
      prescriptionName
      documentType
      orderRanking
      isEditable
      editableDocumentId
      html
      hasUncommittedChanges
      viewed
      approved
      version
      isSimReqAttachment
    }
  }
`;

export const SUBMIT_PRESCRIPTION = gql`
  mutation submitPrescription($id: ID!, $status: String!, $resubmitSimulation: Boolean) {
    submitPrescription(id: $id, status: $status, resubmitSimulation: $resubmitSimulation) {
      careplan {
        id
        careplanStatus
      }
    }
  }
`;

export const REVERT_CPOT = gql`
  mutation revertCpotCareplan($id: ID!) {
    revertCpotCareplan(id: $id) {
      careplan {
        id
        careplanStatus
      }
    }
  }
`;

export const GENERATE_EDITABLE_AUTO_DOCS = gql`
  mutation generateEditableAutoDocs($careplanId: ID!) {
    generateEditableAutoDocs(careplanId: $careplanId) {
      success
    }
  }
`;
